"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("../form-constants");
exports.defaultValues = {
    id: '',
    label: '',
    typeLabel: '',
    ariaLabel: '',
    type: form_constants_1.elementTypes.undefined,
    disabled: false,
    hidden: false,
    isPreviewElement: false,
    defaultValue: '',
};
//# sourceMappingURL=form-element-base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/form-element-base.js
// module id = 1122
// module chunks = 0